import { Accessor, createEffect, on, untrack } from 'solid-js';
import { PointCloudStylingCapabilityProvider } from '@trimble/web3d-providers';
import {
  POINT_CLOUD_STYLING_DEFAULTS,
  PointCloudStyling,
} from '@trimble/types';

export function withPointBudget(
  styling: PointCloudStyling,
  budget: number
): PointCloudStyling {
  return { ...styling, point: { ...styling.point, budget } };
}

export function createDefaultPointCloudStyling(
  pointBudget: Accessor<number>
): Accessor<PointCloudStyling> {
  return () => withPointBudget(POINT_CLOUD_STYLING_DEFAULTS, pointBudget());
}

// Deferred: only later changes to the setting override the active styling's
// budget, so a budget restored from a saved view survives until then.
export function applyPointBudgetChanges(
  stylingProvider: PointCloudStylingCapabilityProvider,
  pointBudget: Accessor<number>
): void {
  createEffect(
    on(
      pointBudget,
      (budget) => {
        const styling = untrack(stylingProvider.pointCloudStyling);
        stylingProvider.setPointCloudStyling(withPointBudget(styling, budget));
      },
      { defer: true }
    )
  );
}
